import 'react-perfect-scrollbar/dist/css/styles.css';
import React,{useEffect, useState} from 'react';
import { useRoutes } from 'react-router-dom';
import GlobalStyles from 'src/components/GlobalStyles';
import { UserProvider } from 'src/context/AuthContext';
import { PreferenceProvider } from './context/PreferenceContext';
import {AlertProvider} from 'src/context/AlertContext';
import {firebaseConfig} from 'src/firebase';
import './index.css';
import routes from 'src/routes';
import { doc } from 'firebase/firestore'; 
import { initializeFirestore,enableIndexedDbPersistence,disableNetwork, getFirestore,enableNetwork } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; 
import LoadingView from 'src/views/auth/LoadingView';
import LogRocket from 'logrocket';
import {fnBrowserDetect} from 'src/utils';
import BrowserNotSupport from './views/errors/BrowserNotSupport';
import { useIdleTimer } from 'react-idle-timer';
import { useFirestoreDocData } from 'reactfire';

// import { useInitPerformance } from 'ReactFire';
import {
  FirebaseAppProvider,
  FirestoreProvider,
  useFirebaseApp, 
  AuthProvider,
  useInitFirestore
} from 'reactfire';

const App:React.VFC = () => {
  const routing = useRoutes(routes);
  const app = useFirebaseApp();
  const db = getFirestore(app);
  const auth = getAuth(app);
  const versionRef = doc(db, 'settings', 'general');
  const [currentVersion, setCurrentVerson] = useState('');
  const { status:versionStatus, data:versionData } = useFirestoreDocData(versionRef);

  const isUpdateAvailable = versionStatus==='success'?versionData?.version:false;
  console.log('isUpdateAvailable',isUpdateAvailable);

  useEffect(()=>{
    console.log('currentVersion',currentVersion);

    if(isUpdateAvailable!==undefined&& isUpdateAvailable!==false){
      setCurrentVerson(versionData.version);
    }
    if(currentVersion!==''){
      window.location.reload();
    }

  },[isUpdateAvailable]);

  const { status:firestoreStatus, data: firestoreInstance } = useInitFirestore(async (firebaseApp) => {
    const db = initializeFirestore(firebaseApp, {});
    try{
      await enableIndexedDbPersistence(db);
      return db;
    }
    catch{
      return db;
    }
  });



  const handleOnIdle = async (event: any) => {
    // console.log('user is idle', event);
    console.log('last active', getLastActiveTime());
    await disableNetwork(db);

  };

  const handleOnActive = async (event: any) => {
    console.log('time remaining', getRemainingTime());
    await enableNetwork(db);
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 5,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500
  });


  if (firestoreStatus === 'loading' || versionStatus ==='loading') {
    return <LoadingView/>;
  }

  return (
    <AlertProvider>
      <AuthProvider sdk={auth}>
        <FirestoreProvider sdk={firestoreInstance}>
          <UserProvider>
            <PreferenceProvider>
           
              <GlobalStyles />
              
              {routing}

              {/* {isUpdateAvailable && (
                <SnackbarContent message="New Version is available" action={
                  <Button size="small" variant='outlined' style={{color:'red'}}
                    onClick={()=>window.location.reload()}>
                    Refresh
                  </Button>
                } style={{position:'fixed',bottom:24,left:24, zIndex:10000}}/>
              )} */}
            </PreferenceProvider>
          </UserProvider>
        </FirestoreProvider>
      </AuthProvider>
    </AlertProvider>

  );
};

const FirebaseParent:React.VFC = ()=>{
  const [update,setUpdate] = useState(true);
  useEffect( () => {
    LogRocket.init(process.env.REACT_APP_LOGROCKET_APPID??'');
  }, []);
  

  if(fnBrowserDetect()==='firefox'){
    return (<BrowserNotSupport/>);
  }
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <App/>
    </FirebaseAppProvider>
  );
};



export default FirebaseParent;

